import _ from 'lodash'
import 'js/public-path'
import store from 'js/store'
import * as components from 'js/modules/components'
import * as mediaquery from 'js/utility/mquery.js'

import 'scss/app.scss'

// mediaqueries

mediaquery.add({
    mediaquery: '(max-width: 768px)',
    name: 'small'
})

mediaquery.add({
    mediaquery: '(min-width: 769px) and (max-width: 1024px)',
    name: 'medium'
})

mediaquery.add({
    mediaquery: '(min-width: 1025px) and (max-width: 1440px)',
    name: 'large'
})

mediaquery.add({
    mediaquery: '(min-width: 1441px)',
    name: 'wide'
})

window.theme = {
    modules: {
        components
    },
    store,
    mediaquery
}

// init components
_.each(theme.modules, module => {
    if (_.isFunction(module.initialize)) {
        module.initialize(theme)
    }
})

// ready components
Promise.resolve()
    .then(() => new Promise(resolve => {
        if (document.readyState === 'loading') {
            document.addEventListener('readystatechange', () => resolve())
            return
        } else {
            resolve()
        }
    }))
    .then(() => {
        _.each(theme.modules, module => {
            if (_.isFunction(module.ready)) {
                module.ready(theme)
            }
        })
    })


// WEBPACK FOOTER //
// ./app/theme/js/index.js